import { hasGlobalRole } from "@/auth/permissions";
import type { AuthSessionContext, TokenPayload } from "@/auth/sessionTypes";

import { fetchMyConferenceContext } from "./api";

export function mustChangePasswordFromPayload(payload: TokenPayload): boolean {
  return Boolean(payload.must_change_password ?? payload.user?.must_change_password);
}

export async function resolveConferencePostLoginPath(
  session: AuthSessionContext,
  payload?: TokenPayload,
): Promise<string> {
  if (hasGlobalRole(session.global_roles, "admin")) {
    return "/admin";
  }
  if (payload && mustChangePasswordFromPayload(payload)) {
    return "/set-password";
  }
  if (session.user?.must_change_password) {
    return "/set-password";
  }
  try {
    const ctx = await fetchMyConferenceContext();
    if (ctx.is_reviewer && !ctx.has_registration) {
      return "/reviews";
    }
  } catch {
    /* fall through to dashboard */
  }
  return "/dashboard";
}
